import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Linkedin, MessageCircle } from 'lucide-react';

const LOGO_URL = "https://assets.lolcdn.xyz/logo-2.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#003333] py-16 md:py-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <img
              src={LOGO_URL}
              alt="LOLCorp Logo"
              className="h-10 mb-6 brightness-0 invert"
            />
            <p className="text-white/60 max-w-md leading-relaxed mb-4">
              UK-registered software company building custom internal systems for 
              modern businesses. Enterprise-grade solutions, tailored to your needs.
            </p>
            <p className="text-white/40 text-sm">
              71-75 Shelton Street, Covent Garden<br />
              London, WC2H 9JQ, United Kingdom
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="/#about" 
                  className="text-white/60 hover:text-white transition-colors inline-flex items-center gap-1"
                >
                  About Us
                </a>
              </li>
              <li>
                <a 
                  href="/#services" 
                  className="text-white/60 hover:text-white transition-colors inline-flex items-center gap-1"
                >
                  Internal Systems
                </a>
              </li>
              <li>
                <Link 
                  to="/maintenance" 
                  className="text-white/60 hover:text-white transition-colors inline-flex items-center gap-1"
                >
                  Maintenance Plans
                </Link>
              </li>
              <li>
                <Link 
                  to="/instant-quote" 
                  className="text-white/60 hover:text-white transition-colors inline-flex items-center gap-1"
                >
                  Instant Quote
                </Link>
              </li>
              <li>
                <a 
                  href="/#contact" 
                  className="text-white/60 hover:text-white transition-colors inline-flex items-center gap-1"
                >
                  Contact
                </a>
              </li>
              <li>
                <Link 
                  to="/consultation" 
                  className="text-white/60 hover:text-white transition-colors inline-flex items-center gap-1"
                >
                  Book Consultation
                  <ArrowUpRight className="w-4 h-4" />
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact</h4>
            <ul className="space-y-4 text-white/60">
              <li>
                <a href="mailto:hello@lolcorp.co.uk" className="hover:text-white transition-colors">
                  hello@lolcorp.co.uk
                </a>
              </li>
              <li>
                <a href="tel:+442035763417" className="hover:text-white transition-colors">
                  +44 20 3576 3417
                </a>
              </li>
            </ul>
            
            {/* Social Links */}
            <div className="flex gap-4 mt-6">
              <a 
                href="https://www.linkedin.com/company/lolcorp/" 
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 border border-white/20 hover:border-white/50 rounded-full text-white/60 hover:text-white transition-all"
                data-testid="social-linkedin"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="https://wa.link/8qxh5o" 
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 border border-white/20 hover:border-white/50 rounded-full text-white/60 hover:text-white transition-all"
                data-testid="social-whatsapp"
              >
                <MessageCircle className="w-5 h-5" />
              </a>

              
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {currentYear} LOLCorp Ltd. All rights reserved. Company No. 15380538
          </p>
          
          <button
            onClick={scrollToTop}
            className="text-white/40 hover:text-white text-sm flex items-center gap-2 transition-colors"
            data-testid="scroll-to-top"
          >
            Back to top
            <ArrowUpRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </footer>
  );
};
